import React from 'react'
import {NotificationsContext} from 'context/NotificationsContext'

// Legacy way for classes components that can not use context hook
const withNotifications = () => WrappedComponent => props =>
  (
    <NotificationsContext.Consumer>
      {({showNotification}) => (
        <WrappedComponent showNotification={showNotification} {...props}>
          {props.children}
        </WrappedComponent>
      )}
    </NotificationsContext.Consumer>
  )

export default withNotifications
